import { Pipe, PipeTransform } from '@angular/core';
import { ConditioningService } from '@xpo-ltl/common-services';

@Pipe({
  name: 'proNumberFormatter',
})
export class ProNumberFormatterPipe implements PipeTransform {

  constructor(private conditioningService: ConditioningService) {}

  transform(value: string, args?: any): string {
    let formatDigits = 10;
    if (args) {
      formatDigits = Number.parseInt(args, 10);
    }
    return this.conditioningService.conditionProNumber(value, formatDigits);
  }

  convertToStandard11DigitPro(value): string {
    value = `${value.replace('-', '')}`;
    if (value.length === 9) {
      return (value = `0${value.slice(0, 3)}0${value.slice(3)}`);
    }
    return value;
  }
}
